
<multiselect
  v-model="selectedValue"
  placeholder="Click to select"
  label="name"
  track-by="id"
  :options="selectOptions"
  :multiple="true"
  :taggable="false"
  class="multiselect-actions"
  :searchable="false"
>
</multiselect>
